import {
  RESEND_INVOICE_FAILURE,
  RESEND_INVOICE_REQUEST,
  RESEND_INVOICE_RESET,
  RESEND_INVOICE_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const resendInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case RESEND_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case RESEND_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case RESEND_INVOICE_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default resendInvoiceReducer
